import $ from 'jquery';
var jQuery = $;

export var wg_errors = {
    ERROR_LIST_SELECTOR: '.js-wg-error-list',
    ERROR_LIST_ITEMS_SELECTOR: '.js-wg-error-list>.message-box-wrapper',
    MESSAGE_TEMPLATE_SELECTOR: '.js-message-box-template>:first-child',
    MESSAGE_TYPE_ERROR: 'message-box__error',
    MESSAGE_TITLE_SELECTOR: '.message-box_title',
    MESSAGE_CONTENT_SELECTOR: '.message-box_content',
    MESSAGE_ICON_SELECTOR: '.message-box_icon',
    MESSAGE_CLOSE_BUTTON_SELECTOR: '.js-message-box_close-btn',

};

var $body;

$(function () {
    $body = $('body');

    $(wg_errors.MESSAGE_CLOSE_BUTTON_SELECTOR).click(function () {
        var $wrapper = $(this).closest('.message-box-wrapper');
        $wrapper.animate({
            height: '0',
        }, 150, 'swing', function () {
            $wrapper.remove();
            $(window).trigger('resize');
        });
    });
});

wg_errors.showError = function (message, optionalTitle) {
    var $messageIcon;
    var $errorList = $(wg_errors.ERROR_LIST_SELECTOR),
        optionalTitle = optionalTitle || "";

    var errorMessage = $($.parseHTML(message));

    if ($errorList.length == 0) {
        alert(errorMessage.text());
    } else {

        var $message = $errorList.find(wg_errors.MESSAGE_TEMPLATE_SELECTOR).clone(true);
        $message.find(wg_errors.MESSAGE_CLOSE_BUTTON_SELECTOR).show();
        $message.children().addClass(wg_errors.MESSAGE_TYPE_ERROR);
        if (optionalTitle === "") {
            $message.find(wg_errors.MESSAGE_TITLE_SELECTOR).append(gettext("Error"));
        } else {
            $message.find(wg_errors.MESSAGE_TITLE_SELECTOR).append(gettext("Error") + ": " + optionalTitle);
        }
        $message.find(wg_errors.MESSAGE_CONTENT_SELECTOR).append(errorMessage);
        $messageIcon = $message.find(wg_errors.MESSAGE_ICON_SELECTOR);
        $messageIcon.attr('src', STATIC_URL + 'portal/img/svg-icons/wg_ui/messages/icon_error.svg').addClass('js-svg-icon');
        SVGInjector($messageIcon);

        $errorList.append($message);


        var scrollTop = $body.scrollTop();

        // 120 is just enough space to see the list.
        // Anything below 60 or so, the error list shows behind the header
        // Anything less than 120 and it starts to look cramped.
        var errorlistTop = $errorList.offset().top - 120;

        if (errorlistTop < scrollTop)
            $body.scrollTop(errorlistTop);

        $(window).trigger('resize');
    }

};
wg_errors.clearErrors = function () {
    $(wg_errors.ERROR_LIST_ITEMS_SELECTOR).remove();
    $(window).trigger('resize');
};
